<template>
  <el-drawer
    v-model="drawerOpen"
    title="主题编辑"
    direction="rtl"
    size="320px"
    destroy-on-close
    class="layout-breadcrumb-seting-drawer"
    @closed="onDrawerClose"
  >
    <el-scrollbar class="layout-breadcrumb-seting-bar">
      <el-divider content-position="center">布局切换</el-divider>
      <!--
        布局缩略图视觉对齐 EB setings.vue（defaults / columns / classic / transverse）
        不用 el-container/el-aside：EP 全局 .el-aside{width:300px} 会把「分栏」挤成两根竖条
      -->
      <div class="layout-drawer-content-flex">
        <div
          class="layout-drawer-content-item"
          :class="{ 'drawer-layout-active': themeConfig.layout === 'defaults' }"
          title="默认布局"
          @click="onSetLayout('defaults')"
        >
          <div class="lp lp--row">
            <div class="lp__side lp__side--17 lp__gap-r" />
            <div class="lp lp--col lp__grow">
              <div class="lp__head lp__gap-b" />
              <div class="lp__main" />
            </div>
          </div>
        </div>
        <div
          class="layout-drawer-content-item"
          :class="{ 'drawer-layout-active': themeConfig.layout === 'columns' }"
          title="分栏布局"
          @click="onSetLayout('columns')"
        >
          <div class="lp lp--row">
            <div class="lp__side lp__side--10 lp__gap-r" />
            <div class="lp__side lp__side--17 lp__side--muted lp__gap-r" />
            <div class="lp lp--col lp__grow">
              <div class="lp__head lp__gap-b" />
              <div class="lp__main" />
            </div>
          </div>
        </div>
        <div
          class="layout-drawer-content-item"
          :class="{ 'drawer-layout-active': themeConfig.layout === 'classic' }"
          title="经典布局"
          @click="onSetLayout('classic')"
        >
          <div class="lp lp--col">
            <div class="lp__side lp__side--bar lp__gap-b" />
            <div class="lp lp--row lp__grow">
              <div class="lp__side lp__side--17 lp__side--muted lp__gap-r" />
              <div class="lp__main" />
            </div>
          </div>
        </div>
        <div
          class="layout-drawer-content-item"
          :class="{ 'drawer-layout-active': themeConfig.layout === 'transverse' }"
          title="横向布局"
          @click="onSetLayout('transverse')"
        >
          <div class="lp lp--col">
            <div class="lp__side lp__side--bar lp__gap-b" />
            <div class="lp__main" />
          </div>
        </div>
      </div>

      <!-- 界面设置 / 显示 / 其它：行结构对齐 EB setings.vue（左标签右控件，紧凑行距） -->
      <el-divider content-position="center">界面设置</el-divider>
      <div class="layout-breadcrumb-seting-bar-flex mb10">
        <div class="layout-breadcrumb-seting-bar-flex-label">主题</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-select
            v-model="themeConfig.themeStyle"
            placeholder="请选择"
            size="small"
            style="width: 90px"
            @change="onThemeStyleChange"
          >
            <el-option label="蓝黑" value="theme-1" />
            <el-option label="蓝白" value="theme-2" />
            <el-option label="绿黑" value="theme-3" />
            <el-option label="绿白" value="theme-4" />
            <el-option label="紫黑" value="theme-5" />
            <el-option label="紫白" value="theme-6" />
            <el-option label="红黑" value="theme-7" />
            <el-option label="红白" value="theme-8" />
            <el-option v-if="themeConfig.layout === 'columns'" label="渐变" value="theme-9" />
          </el-select>
        </div>
      </div>

      <div
        v-if="themeConfig.layout === 'columns' || themeConfig.layout === 'defaults'"
        class="layout-breadcrumb-seting-bar-flex"
      >
        <div class="layout-breadcrumb-seting-bar-flex-label">菜单水平折叠</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isCollapse" size="small" @change="onConfigChange" />
        </div>
      </div>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">菜单手风琴</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isUniqueOpened" size="small" @change="onConfigChange" />
        </div>
      </div>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">固定 Header</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isFixedHeader" size="small" @change="onConfigChange" />
        </div>
      </div>

      <el-divider content-position="center">界面显示</el-divider>
      <div class="layout-breadcrumb-seting-bar-flex">
        <div class="layout-breadcrumb-seting-bar-flex-label">侧边栏 Logo</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isShowLogo" size="small" @change="onConfigChange" />
        </div>
      </div>
      <div
        class="layout-breadcrumb-seting-bar-flex mt15"
        :style="{
          opacity:
            themeConfig.layout === 'classic' || themeConfig.layout === 'transverse' ? 0.5 : 1,
        }"
      >
        <div class="layout-breadcrumb-seting-bar-flex-label">面包屑</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch
            v-model="themeConfig.isBreadcrumb"
            size="small"
            :disabled="themeConfig.layout === 'classic' || themeConfig.layout === 'transverse'"
            @change="onConfigChange"
          />
        </div>
      </div>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">面包屑图标</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isBreadcrumbIcon" size="small" @change="onConfigChange" />
        </div>
      </div>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">历史菜单</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isTagsview" size="small" @change="onConfigChange" />
        </div>
      </div>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">Footer</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isFooter" size="small" @change="onConfigChange" />
        </div>
      </div>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">灰色模式</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isGrayscale" size="small" @change="onGrayscaleChange" />
        </div>
      </div>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">色弱模式</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-switch v-model="themeConfig.isInvert" size="small" @change="onInvertChange" />
        </div>
      </div>

      <el-divider content-position="center">其它设置</el-divider>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">历史菜单风格</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-radio-group
            v-model="themeConfig.tagsStyle"
            :disabled="!themeConfig.isTagsview"
            size="small"
            @change="onConfigChange"
          >
            <el-radio-button value="tags-style-one">卡片</el-radio-button>
            <el-radio-button value="tags-style-four">灵动</el-radio-button>
            <el-radio-button value="tags-style-five">圆滑</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="layout-breadcrumb-seting-bar-flex mt15">
        <div class="layout-breadcrumb-seting-bar-flex-label">主页面切换动画</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-radio-group v-model="themeConfig.animation" size="small" @change="onConfigChange">
            <el-radio-button value="slide-left">左滑</el-radio-button>
            <el-radio-button value="opacitys">透明</el-radio-button>
            <el-radio-button value="slide-right">右滑</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div
        v-if="themeConfig.layout === 'columns' || themeConfig.layout === 'classic'"
        class="layout-breadcrumb-seting-bar-flex mt15"
      >
        <div class="layout-breadcrumb-seting-bar-flex-label">菜单高亮风格</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-radio-group v-model="themeConfig.columnsAsideStyle" size="small" @change="onConfigChange">
            <el-radio-button value="columns-round">圆角</el-radio-button>
            <el-radio-button value="columns-card">卡片</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div
        v-if="themeConfig.layout === 'columns'"
        class="layout-breadcrumb-seting-bar-flex mt15 mb28"
      >
        <div class="layout-breadcrumb-seting-bar-flex-label">顶级菜单风格</div>
        <div class="layout-breadcrumb-seting-bar-flex-value">
          <el-radio-group v-model="themeConfig.columnsAsideLayout" size="small" @change="onConfigChange">
            <el-radio-button value="columns-horizontal">水平</el-radio-button>
            <el-radio-button value="columns-vertical">垂直</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="copy-config">
        <el-button class="copy-config-btn-reset" size="small" @click="themeStore.resetConfig()">
          一键恢复默认
        </el-button>
      </div>
    </el-scrollbar>
  </el-drawer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useCrmebThemeConfigStore, { type CrmebLayoutType } from '@/store/modules/themeConfig';

const themeStore = useCrmebThemeConfigStore();
const themeConfig = computed(() => themeStore.themeConfig);

const drawerOpen = computed({
  get: () => themeConfig.value.isDrawer,
  set: (v: boolean) => {
    if (v) themeStore.openSettingsDrawer();
    else themeStore.closeSettingsDrawer();
  },
});

function onConfigChange() {
  themeStore.onConfigChange();
}

function onThemeStyleChange() {
  themeStore.setThemeStyle(themeConfig.value.themeStyle);
}

function onGrayscaleChange(val: boolean) {
  themeStore.setFilter('grayscale', val);
}

function onInvertChange(val: boolean) {
  themeStore.setFilter('invert', val);
}

function onSetLayout(layout: CrmebLayoutType) {
  themeStore.setLayout(layout);
}

function onDrawerClose() {
  themeStore.closeSettingsDrawer();
}
</script>

<style scoped lang="scss">
.w10 {
  width: 10px;
}
.mr5 {
  margin-right: 5px;
}
.mb5 {
  margin-bottom: 5px;
}
.mb10 {
  margin-bottom: 10px;
}
.mt15 {
  margin-top: 15px;
}
.mb28 {
  margin-bottom: 28px;
}

.layout-breadcrumb-seting-bar {
  padding: 0 15px;
  height: calc(100vh - 80px);

  /* EP divider 默认上下间距偏大，收紧对齐 EB */
  :deep(.el-divider) {
    margin: 18px 0;
  }
  :deep(.el-radio-button--small .el-radio-button__inner) {
    padding: 5px 8px;
  }
  :deep(.el-switch--small) {
    height: 18px;
  }
}

.layout-breadcrumb-seting-bar-flex {
  display: flex;
  align-items: center;

  &-label {
    flex: 1;
    color: var(--prev-color-text-primary, #606266);
    font-size: 14px;
    line-height: 1.4;
  }

  &-value {
    flex-shrink: 0;
  }
}

.layout-drawer-content-flex {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  margin: 0 -5px 10px;

  .layout-drawer-content-item {
    width: 107px;
    height: 70px;
    cursor: pointer;
    border: 1px solid transparent;
    position: relative;
    padding: 6px;
    background: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    margin: 10px;
    box-sizing: border-box;

    &.drawer-layout-active {
      border-color: var(--prev-color-primary, #4073fa);
    }
    &:hover:not(.layout-drawer-content-item--disabled) {
      border-color: var(--prev-color-primary, #4073fa);
    }
    &--disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }
}

/* 缩略图：尺寸写死，完全避开 EP layout 类名 */
.lp {
  display: flex;
  box-sizing: border-box;
  border-radius: 2px;
  overflow: hidden;
}
.layout-drawer-content-item > .lp {
  width: 100%;
  height: 100%;
}
.lp--row {
  flex-direction: row;
}
.lp--col {
  flex-direction: column;
}
.lp__grow {
  flex: 1;
  min-width: 0;
  min-height: 0;
}
.lp__gap-r {
  margin-right: 5px;
}
.lp__gap-b {
  margin-bottom: 5px;
}
.lp__side {
  flex-shrink: 0;
  border-radius: 2px;
  background-color: var(--prev-tag-active-color, #4073fa);
}
.lp__side--10 {
  width: 10px;
}
.lp__side--17 {
  width: 17px;
}
.lp__side--bar {
  width: 100%;
  height: 10px;
}
.lp__side--muted {
  opacity: 0.5;
}
.lp__head {
  flex-shrink: 0;
  height: 10px;
  border-radius: 2px;
  background-color: var(--prev-color-seting-header, #b3c0d1);
}
.lp__main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  border-radius: 2px;
  border: 1px dashed var(--prev-color-primary, #4073fa);
  background-color: var(--prev-color-seting-main, #e9eef3);
}

.copy-config-btn-reset {
  width: 100%;
  margin: 16px 0 24px;
}
</style>
